// ExcelJS is lazy-loaded to keep it out of the initial app bundle.
let excelJsPromise: Promise<typeof import('exceljs')> | null = null;

export function loadExcelJs(): Promise<typeof import('exceljs')> {
  return (excelJsPromise ??= import('exceljs').then((m) => (m.default ?? m) as typeof import('exceljs')));
}

/**
 * Removes characters forbidden in Excel worksheet names and truncates to the 31-character limit.
 * Forbidden characters: \ / ? * [ ] :
 */
export function sanitizeSheetName(name: string): string {
  return name.replace(/[\\/?*[\]:]/g, '').slice(0, 31);
}

export function sanitizeFilename(name: string): string {
  return name.replace(/[\\/:*?"<>|]/g, '_').trim();
}

/** Returns the Excel numFmt string for a date column based on the report grouping level. */
export function dateCellNumFmt(groupBy: 'day' | 'month' | 'year'): string {
  if (groupBy === 'month') return 'mmm yyyy';
  if (groupBy === 'year') return 'yyyy';
  return 'dd/mm/yyyy';
}

/** Returns the Excel numFmt string that displays a number followed by the currency code. */
export function currencyNumFmt(code: string): string {
  return `#,##0.00 "${code}"`;
}

/** Adds a row to the sheet and applies per-column number formats where specified. */
export function addFormattedRow(
  sheet: import('exceljs').Worksheet,
  values: (string | number | Date | undefined)[],
  formats: (string | undefined)[],
): void {
  const row = sheet.addRow(values);
  formats.forEach((fmt, idx) => {
    if (fmt) row.getCell(idx + 1).numFmt = fmt;
  });
}

/**
 * Sets column widths based on column type.
 * date=12, currency=16, text=20
 */
export function setColumnWidths(
  sheet: import('exceljs').Worksheet,
  columnTypes: ('date' | 'currency' | 'text')[],
): void {
  const widths: Record<'date' | 'currency' | 'text', number> = { date: 12, currency: 16, text: 20 };
  columnTypes.forEach((type, idx) => {
    sheet.getColumn(idx + 1).width = widths[type];
  });
}
